import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X } from 'lucide-react'
import logoUrl from '../../../assets/images/doctor-legal/logo-15-trim.png'

const navLinks = [
  { label: 'A Plataforma', href: '#a-plataforma' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Planos', href: '#planos' },
  { label: 'FAQ', href: '#faq' },
]

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80)
      if (mobileOpen) setMobileOpen(false)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [mobileOpen])

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [mobileOpen])

  return (
    <>
      <motion.header
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled || mobileOpen
            ? 'bg-surface-elevated backdrop-blur-[12px] border-b border-border-subtle shadow-nav py-3'
            : 'bg-surface-elevated md:bg-transparent py-5'
        }`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="max-w-7xl mx-auto px-6 w-full flex items-center justify-between">
          <a href="#" className="flex items-center gap-2">
            <img
              src={logoUrl}
              alt="Doctor Legal"
              className="h-9 md:h-10 w-auto object-contain"
            />
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-[14px] font-semibold text-text-secondary hover:text-accent-primary transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center">
            <a href="#planos" className="btn-primary py-2 px-6 text-[14px]">
              Fazer meu pré-cadastro
            </a>
          </div>

          <button
            type="button"
            className="md:hidden flex items-center justify-center p-2 rounded-lg text-text-primary"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            className="fixed inset-0 z-40 bg-surface-elevated flex flex-col pt-24 px-6 pb-10"
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            <nav className="flex flex-col gap-1">
              {navLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-[18px] font-semibold text-text-primary py-4 border-b border-border-subtle hover:text-accent-primary transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <a
              href="#planos"
              onClick={() => setMobileOpen(false)}
              className="btn-primary mt-8 w-full text-center text-[15px] py-4"
            >
              Fazer pré-cadastro
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
